import { Navigate } from 'react-router-dom';

// eslint-disable-next-line react/prop-types
export const AuthRoute = ({ children }) => {
  const token = window.localStorage.getItem('token');

  //   user is unauthenticated
  if (!token) {
    return children;
  }

  return <Navigate to="/dashboard" />;
};
